import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL_MESP;
const tokenUser = JSON.parse(sessionStorage.getItem("AuthUser"))?.token;

class AuthService
{
  getCurrentAuthUser() {
    return JSON.parse(sessionStorage.getItem("AuthUser"));
  }

  loginStudent(id, password) {
    return axios.post(API_URL + "signin/simpleSigninStudent", { id, password });
  }

  loginResponsableServiceStage(id, password) {
    return axios.post(API_URL + "signin/simpleSigninResponsableServiceStage", {
      id,
      password,
    });
  }

  loginPedagogicalCoordinator(id, password) {
    return axios.post(API_URL + "signin/simpleSigninPedagogicalCoordinator", {
      id,
      password,
    });
  }

  loginTeacher(id, password) {
    return axios.post(API_URL + "signin/simpleSigninTeacher", { id, password });
  }

  forgotResponsableServiceStagePassword(id, password) {
    return axios.post(API_URL + "signin/forgotResponsableServiceStagePassword", {
      id,
      password,
    });
  }

  secureStudentPassword(idEt, newPasswordStudent) {
    return axios.post(
      API_URL + "secureStudentPassword/" + idEt + "/" + encodeURIComponent(newPasswordStudent),
      {}, // Body vide car les données sont dans l'URL
      {
        headers: {
          Authorization: `Bearer ${tokenUser}`
        }
      }
    );
}

  securePedagogicalCoordinatorPassword(idEt, newPasswordPedagogicalCoordinator) {
    console.log('HILAHILA : ', sessionStorage.getItem("tempToken"));

    return axios.post(
        API_URL + "securePedagogicalCoordinatorPassword/" + idEt + "/" + encodeURIComponent(newPasswordPedagogicalCoordinator)
        ,
        {}, // Body vide car les données sont dans l'URL
        {
          headers: {
            Authorization: `Bearer ${tokenUser}`
          }
        });
  }

  secureResponsableServiceStagePassword(idResponsible, newPasswordResponsible) {
    return axios.post(
      API_URL +
        "secureResponsableServiceStagePassword/" +
        idResponsible +
        "/" +
        encodeURIComponent(newPasswordResponsible)
        ,
        {}, // Body vide car les données sont dans l'URL
        {
          headers: {
            Authorization: `Bearer ${tokenUser}`
          }
        });
  }

  secureTeacherPassword(idEns, newPasswordTeacher) {
    return axios.post(
      API_URL + "secureTeacherPassword/" + idEns + "/" + encodeURIComponent(newPasswordTeacher)
      ,
      {}, // Body vide car les données sont dans l'URL
      {
        headers: {
          Authorization: `Bearer ${tokenUser}`
        }
      });
  }

  logoutResponsableServiceStage() {
    sessionStorage.removeItem("AuthUser");
    sessionStorage.removeItem("persist:root");
    window.location.href = "/";
  }

  logoutStudent() {
    sessionStorage.removeItem("AuthUser");
    window.location.href = "/";
  }

  logoutTeacher() {
    sessionStorage.removeItem("AuthUser");
    sessionStorage.removeItem("persist:root");
    window.location.href = "/";
  }

  logoutPedagogicalCoordinator() {
    sessionStorage.removeItem("AuthUser");
    sessionStorage.removeItem("persist:root");
    window.location.href = "/";
  }

  validateUniquePlanification(idUser, idEtToSTN)
  {
    return axios.get(API_URL + "validateUniquePlanification/" + idUser + "/" + idEtToSTN, {
      headers: {
        Authorization: `Bearer ${tokenUser}`
      }
    });
  }

  validateAndNotifySoutenanceActors(idUser, idEtToSTN, selectedDate, selectedStartHour, selectedEndHour, salle, pedagogicalEncadrant, presjury, expertEns)
  {
    return axios.get(API_URL + "validateAndNotifySoutenanceActors/" +
        idUser +
        "/" +
        idEtToSTN +
        "/" +
        selectedDate +
        "/" +
        selectedStartHour +
        "/" +
        selectedEndHour +
        "/" +
        salle +
        "/" +
        pedagogicalEncadrant +
        "/" +
        presjury +
        "/" +
        expertEns
      , {
        headers: {
          Authorization: `Bearer ${tokenUser}`
        }
      });
  }

  validateAndNotifySoutenanceActorsForMP(idUser, idEtToSTN)
  {
    return axios.get(API_URL + "validateAndNotifySoutenanceActorsForMP/" + idUser + "/" + idEtToSTN, {
      headers: {
        Authorization: `Bearer ${tokenUser}`
      }
    });
  }

  validateMyDepot(idStu)
  {
      return axios.get(API_URL + "upload/validateMyDepot/" + idStu,{
        headers: {
            Authorization: `Bearer ${tokenUser}` // Ajout du token ici
        }
    });
  }

  registerProjectCompany(
    designation,
    lol,
    addressMail,
    telephone,
    fax,
    paysLibelle,
    sectorEntrepriseLibelle,
    siegeSocial
  ) {

    return axios.post(API_URL + "addProjectCompany/", {
      designation,
      lol,
      addressMail,
      telephone,
      fax,
      paysLibelle,
      sectorEntrepriseLibelle,
      siegeSocial,
    } ,{
      headers: {
          Authorization: `Bearer ${tokenUser}` // Ajout du token ici
      }
  });
  }

  modifyProjectCompany(
	      designation,
	      lol,
	      addressMail,
	      telephone,
	      fax,
	      paysLibelle,
	      sectorEntrepriseLibelle,
	      siegeSocial
	  ) {

	    return axios.post(API_URL + "modifyProjectCompany/", {
	      designation,
	      lol,
	      addressMail,
	      telephone,
	      fax,
	      paysLibelle,
	      sectorEntrepriseLibelle,
	      siegeSocial,
	    }, {
        headers: {
            Authorization: `Bearer ${tokenUser}` // Ajout du token ici
        }
    });
	  }

  addConvention(
    mail,
    dateDebut,
    dateFin,
    nomSociete,
    address,
    telephone,
    responsable
  ) {
    if (address.trim() === "") {
      address = "--";
    }

    if (telephone.trim() === "") {
      telephone = "--";
    }
    return axios.post(
      API_URL +
        "addConvention/" +
        JSON.parse(sessionStorage.getItem("AuthUser")).id,
      {
        mail,
        dateDebut,
        dateFin,
        nomSociete,
        address,
        telephone,
        responsable,
      }
      , {
        headers: {
            Authorization: `Bearer ${tokenUser}` // Ajout du token ici
        }
    });
  }

  modifyConvention(
	      mail,
	      dateDebut,
	      dateFin,
	      nomSociete,
	      address,
	      telephone,
	      responsable
	  ) {

	    if (address.trim() === "") {
	      address = "--";
	    }

	    if (telephone.trim() === "") {
	      telephone = "--";
	    }
	    return axios.post(
	        API_URL +
	        "modifyConvention/" +
	        sessionStorage.getItem("studentId"),
	        {
	          mail,
	          dateDebut,
	          dateFin,
	          nomSociete,
	          address,
	          telephone,
	          responsable,
	        }, {
          headers: {
            Authorization: `Bearer ${tokenUser}`
          }
        }
        );
	  }

  modifyConventionByStudent(studentId,
      mail,
      dateDebut,
      dateFin,
      nomSociete,
      address,
      telephone,
      responsable
  ) {
    if (address.trim() === "") {
      address = "--";
    }

    if (telephone.trim() === "") {
      telephone = "--";
    }
    return axios.post(
        API_URL +
        "modifyConventionByStudent/" +
        studentId,
        {
          mail,
          dateDebut,
          dateFin,
          nomSociete,
          address,
          telephone,
          responsable,
        }
        , {
          headers: {
              Authorization: `Bearer ${tokenUser}` // Ajout du token ici
          }
      });
  }

  createFichePFEP1(studentId, otherMail, adresse, numTel) {

    return axios.post(
      API_URL +
        "updateStudent/" +
        studentId +
        "/" +
        encodeURIComponent(otherMail) +
        "/" +
        encodeURIComponent(adresse) +
        "/" +
        numTel
    );
  }

  addTechnology(nameTechnology) {
    return axios.post(
        `${API_URL}addProjectTechnology/${encodeURIComponent(nameTechnology)}`,
        {}, // Body vide car c'est un POST sans payload
        {
            headers: {
                Authorization: `Bearer ${tokenUser}` // Token bien placé
            }
        }
    );
}

  updateTechnology(oldTechnologyName, newTechnologyName) {
    return axios.post(
      API_URL +
        "updateProjectTechnology/" +
        encodeURIComponent(oldTechnologyName) +
        "/" +
        encodeURIComponent(newTechnologyName)
        ,{
          headers: {
              Authorization: `Bearer ${tokenUser}` // Ajout du token ici
          }
      });
  }

  deleteTechnologyByName(nameTechnology) {
    return axios.delete(API_URL + "projectTechnologies/" + encodeURIComponent(nameTechnology),{
      headers: {
          Authorization: `Bearer ${tokenUser}` // Ajout du token ici
      }
  });
  }

  deleteSupervisorCompanyByEmail(email) {
    return axios.get(API_URL + "deleteCompanySupervisorByMail/" + email,{
      headers: {
          Authorization: `Bearer ${tokenUser}` // Ajout du token ici
      }
  });
  }

  addProjectSupervisor(
    idEt,
    projectSupervisorFirstName,
    projectSupervisorLastName,
    projectSupervisorPhoneNumber,
    projectSupervisorEmail
) {
    return axios.post(
        API_URL +
        "addProjectSupervisor/" +
        idEt +
        "/" +
        projectSupervisorFirstName +
        "/" +
        projectSupervisorLastName +
        "/" +
        projectSupervisorPhoneNumber +
        "/" +
        projectSupervisorEmail,
        {}, // Body vide car c'est un POST sans payload
        {
            headers: {
                Authorization: `Bearer ${tokenUser}`
            }
        }
    );
}


  verifyExistMailEncadrantEntreprise(idStudent, mailEE) {
    return axios.get(
      API_URL +
      "verifyExistMailEncadrantEntreprise/" +
      idStudent +
      "/" +
      encodeURIComponent(mailEE)
      ,{
        headers: {
            Authorization: `Bearer ${tokenUser}` // Ajout du token ici
        }
    });
  }

  updateSupervisorCompany(currentStudent, oldEmail, firstName, lastName, numTelephone, email) {
    if (numTelephone === "") {
        numTelephone = "--";
    }

    return axios.post(
        API_URL +
        "updateCompanySupervisor/" +
        currentStudent +
        "/" +
        oldEmail +
        "/" +
        firstName +
        "/" +
        lastName +
        "/" +
        numTelephone +
        "/" +
        email,
        {}, // Body vide car c'est un POST sans payload
        {
            headers: {
                Authorization: `Bearer ${tokenUser}`
            }
        }
    );
}


  addAvenant(
    dateSignatureConvention,
    dateDebut,
    dateFin,
    numSiren,
    qualiteResponsable,
    responsableEntreprise
  ) {

    return axios.post(
      API_URL + "addAvenant/" + JSON.parse(sessionStorage.getItem("AuthUser")).id,
      {
        dateSignatureConvention,
        dateDebut,
        dateFin,
        numSiren,
        qualiteResponsable,
        responsableEntreprise,
      },
      {
        headers: {
            Authorization: `Bearer ${tokenUser}` // Ajout du token ici
        }
    });
  }

  findCompanyByName(designation) {
    return axios.get(API_URL + "/companyByName/" + encodeURIComponent(designation),{
      headers: {
          Authorization: `Bearer ${tokenUser}` // Ajout du token ici
      }
  });
  }

  getReports(studentCode) {
    return axios.get(API_URL + "/reports/" + studentCode, {
      headers: {
          Authorization: `Bearer ${tokenUser}` // Ajout du token ici
      }
  });
  }

  getBalanceSheets(studentCode) {
    return axios.get(API_URL + "/balanceSheets/" + studentCode, {
      headers: {
          Authorization: `Bearer ${tokenUser}` // Ajout du token ici
      }
  });
  }

  getNewspaper(studentCode) {
    return axios.get(API_URL + "/newspaper/" + studentCode, {
      headers: {
          Authorization: `Bearer ${tokenUser}` // Ajout du token ici
      }
  });
  }

  uploadReportV1(file, currentUserCode, checked, onUploadProgress) {
    let formData = new FormData();

    formData.append("file", file);

    return axios.post(
      API_URL + "/upload/reportv1/" + currentUserCode + "/" + checked,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${tokenUser}` // Ajout du token ici
        },
        onUploadProgress,
      }
    );
  }

  uploadReportV2(file, currentUserCode, traineeKind, checked, onUploadProgress) {
    let formData = new FormData();
    formData.append("file", file);
    return axios.post(
      API_URL + "/upload/reportv2/" + currentUserCode + "/" + traineeKind + "/" + checked,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${tokenUser}` // Ajout du token ici
        },
        onUploadProgress,
      }
    );
  }

  uploadPlagiat(file, currentUserCode, checked, onUploadProgress) {
    let formData = new FormData();
    formData.append("file", file);
    return axios.post(
      API_URL + "/upload/plagiat/" + currentUserCode + "/" + checked,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${tokenUser}` // Ajout du token ici
        },
        onUploadProgress,
      }
    );
  }

  uploadSupplement(file, currentUserCode, checked, onUploadProgress) {
    let formData = new FormData();
    formData.append("file", file);
    return axios.post(
      API_URL + "/upload/supplement/" + currentUserCode + "/" + checked,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${tokenUser}` // Ajout du token ici
        },
        onUploadProgress,
      }
    );
  }

  uploadInternshipCertifcate(file, currentUserCode, checked, onUploadProgress) {
    let formData = new FormData();
    formData.append("file", file);
    return axios.post(
      API_URL + "/upload/internshipCertificate/" + currentUserCode + "/" + checked,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${tokenUser}` // Ajout du token ici
        },
        onUploadProgress,
      }
    );
  }

  updateMyBV1(idStu)
  {
    return axios.get(API_URL + "/updateBilanFirstVersion/" + idStu, {
        headers: {
            Authorization: `Bearer ${tokenUser}` // Ajout du token ici
        }
    });
  }

  updateMyBV2(idStu)
  {
    return axios.get(API_URL + "/updateBilanSecondVersion/" + idStu, {
      headers: {
          Authorization: `Bearer ${tokenUser}` // Ajout du token ici
      }
  });
  }

  updateMyBV3(idStu)
  {
    return axios.get(API_URL + "/updateBilanThirdVersion/" + idStu, {
      headers: {
          Authorization: `Bearer ${tokenUser}` // Ajout du token ici
      }
  });
  }

  updateMyDepot(idStu)
  {
    return axios.get(API_URL + "/updateFichePFEDepot/" + idStu, {
      headers: {
          Authorization: `Bearer ${tokenUser}` // Ajout du token ici
      }
  });
  }

  updateMyRLV(idStu)
  {
    return axios.get(API_URL + "/updateReportLaunchVersion/" + idStu, {
      headers: {
          Authorization: `Bearer ${tokenUser}` // Ajout du token ici
      }
  });
  }

  updateMyRFV(idStu)
  {
    return axios.get(API_URL + "/updateReportFinalVersion/" + idStu, {
      headers: {
          Authorization: `Bearer ${tokenUser}` // Ajout du token ici
      }
  });
  }

  updateMyRAP(idStu)
  {
    return axios.get(API_URL + "/updateReportAntiPlagiat/" + idStu, {
      headers: {
          Authorization: `Bearer ${tokenUser}` // Ajout du token ici
      }
  });
  }

  updateMyASP(idStu)
  {
    return axios.get(API_URL + "/updateAttestationStagePFE/" + idStu, {
      headers: {
          Authorization: `Bearer ${tokenUser}` // Ajout du token ici
      }
  });
  }

  updateMyDCS(idStu) {
    return axios.get(API_URL + "/updateSupplement/" + idStu, {
      headers: {
        Authorization: `Bearer ${tokenUser}` // Ajout du token ici
      }
    });
  }
  
  uploadBalanceSheetV1(file, currentUserCode, onUploadProgress) {
    let formData = new FormData();
    formData.append("file", file);
    return axios.post(
      API_URL + "/upload/balanceSheetv1/" + currentUserCode,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${tokenUser}` // Ajout du token ici
        },
        onUploadProgress,
      }
    );
  }

  uploadBalanceSheetV2(file, currentUserCode, onUploadProgress) {
    let formData = new FormData();
    formData.append("file", file);
    return axios.post(
      API_URL + "/upload/balanceSheetv2/" + currentUserCode,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${tokenUser}` // Ajout du token ici
        },
        onUploadProgress,
      }
    );
  }

  uploadBalanceSheetV3(file, currentUserCode, onUploadProgress) {
    let formData = new FormData();
    formData.append("file", file);
    return axios.post(
      API_URL + "/upload/balanceSheetv3/" + currentUserCode,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${tokenUser}` // Ajout du token ici
        },
        onUploadProgress,
      }
    );
  }

  uploadNewspaper(file, currentUserCode, onUploadProgress) {
    let formData = new FormData();
    formData.append("file", file);
    return axios.post(
      API_URL + "/upload/newspaper/" + currentUserCode,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${tokenUser}` ,// Ajout du token ici
        },
        onUploadProgress,
      }
    );
  }

  uploadGanttDiagram(file, currentUserCode, onUploadProgress) {
    let formData = new FormData();
    formData.append("file", file);
    return axios.post(
        API_URL + "/upload/ganttDiagram/" + currentUserCode,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${tokenUser}` // Ajout du token ici
          },
            onUploadProgress,
        }
    );
  }

  uploadCancellationAgreement(file, onUploadProgress) {
    let formData = new FormData();
    formData.append("file", file);
    return axios.post(
        API_URL + "/upload/cancellationAgreement",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${tokenUser}` // Ajout du token ici
          },
          onUploadProgress,
        }
    );
  }

  deleteReportById(id) {
    return axios.delete(API_URL + "files/" + id,{
      headers: {
          Authorization: `Bearer ${tokenUser}` // Ajout du token ici
      }
  });
  }

  findTeachersDisponibility(idUser, selectedDate, startHour, endHour, idPE) {
    return axios.get(
      API_URL +
        "/disponibility/teachers/" +
      idUser +
      "/" +
        selectedDate +
        "/" +
        startHour +
        "/" +
        endHour +
        "/" +
        idPE
      , {
        headers: {
          Authorization: `Bearer ${tokenUser}`
        }
      });
  }

  findClassroomsDisponibility(idUser, selectedDate, startHour, endHour) {
    return axios.get(
      API_URL +
        "/disponibility/classrooms/" +
      idUser +
        "/" +
      selectedDate +
      "/" +
        startHour +
        "/" +
        endHour
      , {
        headers: {
          Authorization: `Bearer ${tokenUser}`
        }
      });
  }

  affectJuryPresidentEns(idUser, idEt, idJuryPresident, date, startHour, endHour) {
    return axios.get(
      API_URL +
        "/affectJuryPresidentEns/" +
        idUser +
        "/" +
        idEt +
        "/" +
        idJuryPresident +
        "/" +
        date +
        "/" +
        startHour +
        "/" +
        endHour
      , {
        headers: {
          Authorization: `Bearer ${tokenUser}`
        }
      });
  }

  affectExpertEns(idUser, idEt, idExpert, date, startHour, endHour) {
    return axios.get(
      API_URL +
        "/affectExpertEns/" +
      idUser +
      "/" +
        idEt +
        "/" +
        idExpert +
        "/" +
        date +
        "/" +
        startHour +
        "/" +
        endHour, {
        headers: {
          Authorization: `Bearer ${tokenUser}`
        }
      }
    );
  }

  affectJuryPresidentNotEns(idUser, idEt, fullNameJuryPresident, date, startHour, endHour) {
    return axios.get(
      API_URL +
        "/affectJuryPresidentNotEns/" +
        idUser +
          "/" +
        idEt +
        "/" +
        fullNameJuryPresident +
        "/" +
        date +
        "/" +
        startHour +
        "/" +
        endHour, {
        headers: {
          Authorization: `Bearer ${tokenUser}`
        }
      }
    );
  }

  affectClassRoom(idUser, idEt, codeSalle, selectedDate, startHour, endHour) {
    return axios.get(
      API_URL +
        "affectClassRoom/" +
        idUser +
        "/" +
        idEt +
        "/" +
        codeSalle +
        "/" +
        selectedDate +
        "/" +
        startHour +
        "/" +
        endHour
      , {
        headers: {
          Authorization: `Bearer ${tokenUser}`
        }
      });
  }

  turnSoutenanceToPlanified(idEtToSTN, idUser)
  {
    return axios.get(API_URL + "/turnSoutenanceToPlanified/" + idEtToSTN + "/" + idUser, {
      headers: {
        Authorization: `Bearer ${tokenUser}`
      }
    });
  }

  downloadStudentPV(idUser, idEt, nomet, classe, juryPresident, expert, pedagogicalEncadrant, stnDate)
  {
      if(juryPresident === undefined || juryPresident === "")
      {
          juryPresident = "--";
      }

      if(expert === undefined || expert === "")
      {
          expert = "--";
      }

      if(pedagogicalEncadrant === undefined || pedagogicalEncadrant === "")
      {
          pedagogicalEncadrant = "--";
      }

      if(stnDate === undefined || stnDate === "")
      {
          stnDate = "--";
      }

      return axios.get(API_URL + "/downloadStudentPV/" +
        idUser +
        "/" +
        idEt +
        "/" +
        nomet +
        "/" +
        classe +
        "/" +
        juryPresident +
        "/" +
        expert +
        "/" +
        pedagogicalEncadrant +
        "/" +
        stnDate, {
        responseType: 'blob',
        headers: {
          Authorization: `Bearer ${tokenUser}`
        }
      });
  }

  downloadBinomePV(idUser, idStu, idEt, nomet, classe, juryPresident, expert, pedagogicalEncadrant, stnDate)
  {
      if(juryPresident === undefined || juryPresident === "")
      {
          juryPresident = "--";
      }

      if(expert === undefined || expert === "")
      {
          expert = "--";
      }

      if(pedagogicalEncadrant === undefined || pedagogicalEncadrant === "")
      {
          pedagogicalEncadrant = "--";
      }

      if(stnDate === undefined || stnDate === "")
      {
          stnDate = "--";
      }

      return axios.get(API_URL + "/downloadBinomePV/" +
        idUser +
        "/" +
        idStu +
        "/" +
        idEt +
        "/" +
        nomet +
        "/" +
        classe +
        "/" +
        juryPresident +
        "/" +
        expert +
        "/" +
        pedagogicalEncadrant +
        "/" +
        stnDate, {
        responseType: 'blob',
        headers: {
          Authorization: `Bearer ${tokenUser}`
        }
      });
  }

  // BUG
  downloadPlanningSoutenanceExcel(idSession, idRespStage)
  {
      return axios.get(API_URL + "/downloadPlanningSoutenanceExcel/" + idSession + "/" + idRespStage,{
        responseType: 'blob',
        headers: {
          Authorization: `Bearer ${tokenUser}`
        }
      });
  }

  downloadPlanningSoutenancePlanifiéesExcel(idSession, idRespStage)
  {
      return axios.get(API_URL + "/downloadPlanningSoutenancePlanifiéesExcel/" + idSession + "/" + idRespStage, {
        responseType: 'blob',
        headers: {
          Authorization: `Bearer ${tokenUser}`
        }
      });
  }

  downloadPlanningSoutenanceNotifiéesExcel(idSession, idRespStage)
  {
      return axios.get(API_URL + "/downloadPlanningSoutenanceNotifiéesExcel/" + idSession + "/" + idRespStage, {
        responseType: 'blob',
        headers: {
          Authorization: `Bearer ${tokenUser}`
        }
      });
  }

  downloadPlanningSoutenanceExcelByFilter(idUser, filteredItems)
  {
      return axios.get(API_URL + "/downloadPlanningSoutenanceExcelByFilter/" + idUser + "/" + filteredItems, {
        responseType: 'blob',
        headers: {
          Authorization: `Bearer ${tokenUser}`
        }
      });
  }

  // EXTEND
  downloadFicheDepotPFE(idUser, idEt, classe, nomet, pairClass)
  {
    return axios.get(API_URL + "/downloadFicheDepotPFE/" +
      idUser +
      "/" +
      idEt +
      "/" +
      classe +
      "/" +
      nomet +
      "/" +
      pairClass, {
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${tokenUser}`
      }
    });
  }

  initiliazeSoutenanceTime(idUser, idEt)
  {
      return axios.get(API_URL + "/initiliazeSoutenanceTime/" + idUser + "/" + idEt, {
        headers: {
          Authorization: `Bearer ${tokenUser}`
        }
      });
  }


  fillFicheDepotPFE(idEt,
                    notePE,
                    onPlanningStg,
                    onBilanPerDebStg,
                    onBilanPerMilStg,
                    onBilanPerFinStg,
                    onFicheEvalMiPar,
                    onFicheEvalFin,
                    onJournalBord,
                    onRapportStg,
                    dateRDV1,
                    dateRDV2,
                    dateRDV3,
                    presenceKindRDV1,
                    presenceKindRDV2,
                    presenceKindRDV3,
                    satisfactionRDV1,
                    satisfactionRDV2,
                    satisfactionRDV3,
                    etatTreat)
  {

    if(notePE === "")
    {
        notePE = 0;
    }

    if(satisfactionRDV1 === "" || satisfactionRDV1 === null)
    {
        satisfactionRDV1 = "--";
    }

    if(satisfactionRDV2 === "" || satisfactionRDV2 === null)
    {
        satisfactionRDV2 = "--";
    }

    if(satisfactionRDV3 === "" || satisfactionRDV3 === null)
    {
        satisfactionRDV3 = "--";
    }

    return axios.get(API_URL + "/fillFicheDepotPFE/" +
      idEt +
      "/" +
      notePE +
      "/" +
      onPlanningStg +
      "/" +
      onBilanPerDebStg +
      "/" +
      onBilanPerMilStg +
      "/" +
      onBilanPerFinStg +
      "/" +
      onFicheEvalMiPar +
      "/" +
      onFicheEvalFin +
      "/" +
      onJournalBord +
      "/" +
      onRapportStg +
      "/" +
      dateRDV1 +
      "/" +
      dateRDV2 +
      "/" +
      dateRDV3 +
      "/" +
      presenceKindRDV1 +
      "/" +
      presenceKindRDV2 +
      "/" +
      presenceKindRDV3 +
      "/" +
      satisfactionRDV1 +
      "/" +
      satisfactionRDV2 +
      "/" +
      satisfactionRDV3 +
      "/" +
      etatTreat, {
      headers: {
        Authorization: `Bearer ${tokenUser}`
      }
    });
  }

  studentsAllAuthorizedToSTN(idRSS)
  {
    return axios.get(API_URL + "/allAuthorizedStudentsToSTN/" + idRSS, {
      headers: {
        Authorization: `Bearer ${tokenUser}`
      }
    });
  }

  studentsAllAuthorizedToSTNForCps(mailCps)
  {
    return axios.get(API_URL + "/allAuthorizedStudentsToSTNforCPS/" + mailCps, {
      headers: {
        Authorization: `Bearer ${tokenUser}`
      }
    });
  }


  checkedStudentsToMultiplePlanifSTN(idRSS, idCheckedStuds)
  {
      return axios.get(API_URL + "/checkedStudentsToMultiplePlanifSTN/" + idRSS + "/" + idCheckedStuds, {
        headers: {
          Authorization: `Bearer ${tokenUser}`
        }
      });
  }

  giveOkConfirmNotifyMultiplePlanif(idUser, idCheckedStuds)
  {
      return axios.get(API_URL + "/giveOkConfirmNotifyMultiplePlanif/" + idUser + "/" + idCheckedStuds, {
        headers: {
          Authorization: `Bearer ${tokenUser}`
        }
      });
  }

  checkAllFilledEntriesToBePlanifiedSTN(idRSS, idCheckedStuds)
  {
      return axios.get(API_URL + "/checkAllFilledEntriesToBePlanifiedSTN/" + idRSS + "/" + idCheckedStuds, {
        headers: {
          Authorization: `Bearer ${tokenUser}`
        }
      });
  }

  checkedStudentsToAdvancedPlanifSTN(idUser, idCheckedStuds, selectedDate, selectedStartHour, selectedEndHour)
  {
      return axios.get(API_URL + "/checkedStudentsToAdvancedPlanifSTN/" + idUser + "/" + idCheckedStuds, {
        headers: {
          Authorization: `Bearer ${tokenUser}`
        }
      });
  }

  checkDisponibilityEncadrantForAP(idRSS, idCheckedStuds, selectedDate, selectedStartHour, selectedEndHour)
  {
      return axios.get(API_URL + "/checkDisponibilityEncadrantForAP/" + idRSS
                               + "/" + idCheckedStuds
                               + "/" + selectedDate
                               + "/" + selectedStartHour
                               + "/" + selectedEndHour, {
        headers: {
          Authorization: `Bearer ${tokenUser}`
        }
      });
  }

  handleAutoPlanifSallesExpertsJuryPresidentsForAP(idRSS, idCheckedStuds, selectedSalles, selectedExperts, selectedJuryPresidents)
  {
      return axios.get(API_URL + "/handleAutoPlanifSallesExpertsJuryPresidentsForAP/" + idRSS
                               + "/" + idCheckedStuds
                               + "/" + selectedSalles
                               + "/" + selectedExperts
                               + "/" + selectedJuryPresidents, {
        headers: {
          Authorization: `Bearer ${tokenUser}`
        }
      });
  }

  soutenancesAllPlanifiées(idRSS)
  {
    return axios.get(API_URL + "/soutenancesAllPlanifiées/" + idRSS, {
      headers: {
        Authorization: `Bearer ${tokenUser}`
      }
    });
  }

  soutenancesAllNotifiées(idUser, Opt,Year)
  {
    return axios.get(API_URL + "/soutenancesAllNotifiées/" + idUser + "/" + Opt + "/" + Year, {
      headers: {
        Authorization: `Bearer ${tokenUser}`
      }
    });
  }

  soutenancesAllNotifiéesForCPS()
  {
    return axios.get(API_URL + "/soutenancesAllNotifiéesForCPS", {
      headers: {
        Authorization: `Bearer ${tokenUser}`
      }
    });
  }

  /*********************************************************** Multiple Planification ***/

  affectExpertMP(idUser, idEt, expertId)
  {
      return axios.get(API_URL + "/affectExpertMP/" + idUser + "/" + + idEt + "/" + expertId, {
        headers: {
          Authorization: `Bearer ${tokenUser}`
        }
      });
  }

  affectJuryPresidentMP(idUser, idEt, juryPresidentId)
  {
      return axios.get(API_URL + "/affectJuryPresidentMP/" + idUser + "/" + idEt + "/" + juryPresidentId, {
        headers: {
          Authorization: `Bearer ${tokenUser}`
        }
      });
  }

  affectSalleMP(idUser, idEt, salleId)
  {
      return axios.get(API_URL + "/affectSalleMP/" + idUser + "/" + idEt + "/" + salleId, {
        headers: {
          Authorization: `Bearer ${tokenUser}`
        }
      });
  }

  affectDateSoutenanceMPWithInit(idUser, idEt, dateSoutenance)
  {
    return axios.get(API_URL + "/affectDateSoutenanceMPWithInit/" + idUser + "/" + idEt + "/" + dateSoutenance, {
      headers: {
        Authorization: `Bearer ${tokenUser}`
      }
    });
  }

  affectStartHourSoutenanceMPWithInit(idUser, idEt, startHourSoutenance)
  {
    return axios.get(API_URL + "/affectStartHourSoutenanceMPWithInit/" + idUser + "/" + idEt + "/" + startHourSoutenance, {
      headers: {
        Authorization: `Bearer ${tokenUser}`
      }
    });
  }

  affectDateSoutenanceMP(idUser, idEt, dateSoutenance)
  {
      return axios.get(API_URL + "/affectDateSoutenanceMP/" + idUser + "/" + idEt + "/" + dateSoutenance, {
        headers: {
          Authorization: `Bearer ${tokenUser}`
        }
      });
  }

  affectStartHourSoutenanceMP(idUser, idEt, startHourSoutenance)
  {
      return axios.get(API_URL + "/affectStartHourSoutenanceMP/" + idUser + "/" + idEt + "/" + startHourSoutenance, {
        headers: {
          Authorization: `Bearer ${tokenUser}`
        }
      });
  }

  affectEndHourSoutenanceMP(idUser, idEt, endHourSoutenance)
  {
      return axios.get(API_URL + "/affectEndHourSoutenanceMP/" + idUser + "/" + idEt + "/" + endHourSoutenance, {
        headers: {
          Authorization: `Bearer ${tokenUser}`
        }
      });
  }

  gotListSudentsByYearAndClass(selectedYear, codeClass, pcMail)
  {
    return axios.get(API_URL + "/listStudentsByYearAndClass/" + selectedYear + "/" + codeClass + "/" + pcMail, {
      headers: {
        Authorization: `Bearer ${tokenUser}`
      }
    });
  }

  gotListSudentsByClassForExp(codeClass, pcMail)
  {
    return axios.get(API_URL + "/listStudentsByClassForExp/" + codeClass + "/" + pcMail, {
      headers: {
        Authorization: `Bearer ${tokenUser}`
      }
    });
  }

  gotListStudentsByClassAndYearForExpPARAM(year, codeClass, pcMail)
  {
    return axios.get(API_URL + "/listStudentsByClassAndYearForExpPARAM/" + year + "/"+ codeClass + "/" + pcMail, {
      headers: {
        Authorization: `Bearer ${tokenUser}`
      }
    });
  }

  findAllAffectedStudentsToAEByYear(idAE, year)
  {
    return axios.get(API_URL + "/findAllAffectedStudentsToAEByYear/" + idAE + "/" + year, {
      headers: {
        Authorization: `Bearer ${tokenUser}`
      }
    });
  }

  findAllAffectedStudentsToAExp(idAExp)
  {
    return axios.get(API_URL + "/findAllAffectedStudentsToAExp/" + idAExp, {
      headers: {
        Authorization: `Bearer ${tokenUser}`
      }
    });
  }


  getJournalStageINGFile(studentCode) {
    return axios.get(`${API_URL}/loadEngineeringJournal/${studentCode}`, {
        headers: {
            Authorization: `Bearer ${tokenUser}`
        }
    });
}

  getAttestationStageINGFile(studentCode) {
	return axios.get(API_URL + "/loadEngineeringAttestation/" + studentCode, {
    headers: {
        Authorization: `Bearer ${tokenUser}`
    }
});
  }

  getRapportStageINGFile(studentCode) {
	// console.log('----------------24.08--------> Got File.');
	return axios.get(API_URL + "/loadEngineeringReport/" + studentCode, {
    headers: {
        Authorization: `Bearer ${tokenUser}`
    }
});
  }

  applyForUpdatingMyDepot(idStudent) {
    return axios.get(
        API_URL +
        "/applyForUpdatingMyDepot/" +
        idStudent
        , {
          headers: {
              Authorization: `Bearer ${tokenUser}` // Ajout du token ici
          }
      });
  }

  uploadJournalStageINGFile(file, currentUserCode, onUploadProgress) {
	 let formData = new FormData();
	 formData.append("file", file);
	 return axios.post(
	    API_URL + "/upload/journalStageING/" + currentUserCode,
	    formData,
	    {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${tokenUser}` // Ajout du token ici
        },
	       onUploadProgress,
	    }
	 );
  }

  confirmMyDepot(idStudent) {
    return axios.get(
        API_URL +
        "/confirmMyDepotStageING/" +
        idStudent
        , {
          headers: {
              Authorization: `Bearer ${tokenUser}` // Ajout du token ici
          }
      });
  }

  uploadAttestationStageINGFile(file, currentUserCode, onUploadProgress) {
	    let formData = new FormData();
	    formData.append("file", file);
	    return axios.post(
	        API_URL + "/upload/attestationStageING/" + currentUserCode,
	        formData,
	        {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${tokenUser}` // Ajout du token ici
            },
                onUploadProgress,
	        }
	    );
	  }

  uploadRapportStageINGFile(file, currentUserCode, onUploadProgress) {
	    console.log('----------------24.08--------> Upload: ' + file.name);
	    let formData = new FormData();

	    formData.append("file", file);

	    return axios.post(
	        API_URL + "/upload/rapportStageING/" + currentUserCode,
	        formData,
	        {
	          headers: {
	            "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${tokenUser}` // Ajout du token ici
	          },
	          onUploadProgress,
	        }
	    );
	  }

  findAllAffectedStudentsToAExpByYear(idAExp, year)
  {
    return axios.get(API_URL + "/findAllAffectedStudentsToAExpByYear/" + idAExp + "/" + year, {
      headers: {
        Authorization: `Bearer ${tokenUser}`
      }
    });
  }

  applyToInitializeMyOwnPassword(email) {
    return axios.post(API_URL + "signin/applyToInitializeMyOwnPassword", { email });
  }

  resetMyOwnPassword(token, password) {
    return axios.get(API_URL + "signin/resetMyOwnPassword/" + token + "/" + password );
  }

  applyToInitializeMyStudentPassword(email) {
    return axios.post(API_URL + "signin/applyToInitializeMyStudentPassword", { email });
  }

  resetMyStudentPassword(token, password) {
    return axios.get(API_URL + "signin/resetMyStudentPassword/" + token + "/" + password );
  }

  applyToInitializeMyCDCPSPassword(email) {
	return axios.post(API_URL + "signin/applyToInitializeMyCDCPSPassword", { email });
  }

  resetMyCDCPSPassword(token, password) {
	return axios.get(API_URL + "signin/resetMyCDCPSPassword/" + token + "/" + password );
  }

  getSignedConventionWithMinio(studentCode) {
    return axios.get(API_URL + "/signedConvention/" + studentCode, {
      headers: {
        Authorization: `Bearer ${tokenUser}` // Ajout du token ici
      }
    });
  }

  getSignedConvention(studentCode) {
    return axios.get(API_URL + "/signedConvention/" + studentCode, {
      headers: {
          Authorization: `Bearer ${tokenUser}` // Ajout du token ici
      }
  });
  }

  uploadSignedConvention(file, currentUserCode, onUploadProgress) {
    let formData = new FormData();
    formData.append("file", file);
    return axios.post(
        API_URL + "/upload/signedConv/" + currentUserCode,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${tokenUser}` // Ajout du token ici
            },
          onUploadProgress,
        }
    );
  }

  getSignedAvenant(studentCode) {
    return axios.get(API_URL + "/signedAvenant/" + studentCode, {
      headers: {
          Authorization: `Bearer ${tokenUser}` // Ajout du token ici
      }
  });
  }

  uploadSignedAvenant(file, currentUserCode, onUploadProgress) {
    let formData = new FormData();
    formData.append("file", file);
    return axios.post(
        API_URL + "/upload/signedAven/" + currentUserCode,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${tokenUser}` // Ajout du token ici
            },
          onUploadProgress,
        }
    );
  }

  /****************************************************************************************************/
  uploadFileWithMinio(file, currentUserCode, onUploadProgress) {
    let formData = new FormData();
    formData.append("file", file);
    return axios.post(
      API_URL + "/uploadFileWithMinio",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${tokenUser}` // Ajout du token ici
        },
        onUploadProgress,
      }
    );
  }

}

export default new AuthService();
